module.exports = __webpack_public_path__ + "media/src/assets/orangewater-21494493703e6ba67af8039ab38b4bba.png";